import React from 'react';

export const Unplugged = (): JSX.Element => (
    <svg
        width="397"
        height="307"
        viewBox="0 0 397 307"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="261" width="135.853" height="134.592" rx="35" fill="#1D57C7" fillOpacity="0.2" />
        <circle cx="308.948" cy="52.1543" r="5.46778" fill="#092252" />
        <circle cx="349.325" cy="52.1543" r="5.46778" fill="#092252" />
        <ellipse cx="329.138" cy="79.9136" rx="5.46778" ry="13.0386" fill="#092252" />
        <path
            d="M136.138 91.8561C115.448 82.4325 62.1447 74.9161 85.4475 132.063C99.4638 160.777 128.677 178.935 185.027 194.129C212.623 205.104 208.999 235.857 188.056 253.365C169.03 269.27 161.739 257.011 132.695 231.296C122.533 222.299 102.43 230.181 96.8867 247.866"
            stroke="#1D57C7"
            strokeOpacity="0.5"
            strokeWidth="10"
            strokeLinecap="round"
        />
        <path
            d="M134.724 91.3706C135.102 68.5629 158.84 62.0642 172.334 61.1357C175.205 60.9382 177.358 63.4702 177.038 66.3295L170.797 122.05C170.478 124.897 167.818 126.921 165.09 126.045C146.676 120.132 134.785 100.457 134.724 91.3706Z"
            fill="#BAD0FB"
        />
        <path
            d="M178.026 56.7192L185.597 56.719C187.839 56.719 189.3 59.0976 188.405 61.1533C177.801 85.517 179.727 113.755 183.547 128.538C184.097 130.665 182.403 132.81 180.217 132.604L172.473 131.875C171.43 131.776 170.506 131.141 170.078 130.184C158.522 104.368 168.279 72.6601 175.403 58.3165C175.896 57.3227 176.916 56.7193 178.026 56.7192Z"
            fill="#4076DD"
        />
        <ellipse
            rx="10.3286"
            ry="37.5394"
            transform="matrix(-0.996506 -0.0835247 -0.0835247 0.996506 184.701 94.5118)"
            fill="#98BBFF"
        />
        <path
            d="M208.245 88.5705L186.59 87.0579C184.627 86.9209 183.169 85.1856 183.371 83.229C183.563 81.3729 185.185 79.9987 187.048 80.1142L208.575 81.4503C211.799 81.6504 217.534 82.8928 216.722 86.0192C215.843 89.4005 211.73 88.814 208.245 88.5705Z"
            fill="#092252"
            stroke="#092252"
        />
        <path
            d="M206.825 112.217L185.17 110.704C183.207 110.567 181.749 108.832 181.951 106.875C182.143 105.019 183.765 103.645 185.628 103.76L207.155 105.096C210.379 105.296 216.114 106.539 215.302 109.665C214.424 113.046 210.31 112.46 206.825 112.217Z"
            fill="#092252"
            stroke="#092252"
            strokeLinecap="round"
        />
    </svg>
);
